<template>
  <div class="nav-container" :class="{'active': isBlack}">
    <router-link to="/about"><img src="../../assets/images/logo/logo.png" alt="" class="logo" /></router-link>
    <div class="nav-bar">
      <router-link :to="{ name: 'about' }" tag="div" class="nav-item" :class="{'active': $route.name == 'about' || $route.name == 'aboutDetail'}"
        >{{$t('aboutUs')}}</router-link
      >
      <router-link :to="{ name: 'portfolio' }" tag="div" class="nav-item" :class="{'active': $route.name == 'portfolio'}"
        >{{$t('portfolio')}}</router-link
      >
      <!-- <router-link :to="{ name: 'team' }" tag="div" class="nav-item" :class="{'active': $route.name == 'team' || $route.name == 'teamDetail'}"
        >{{$t('team')}}</router-link
      > -->
      <router-link :to="{ name: 'newsCenter' }" tag="div" class="nav-item" :class="{'active': $route.name == 'newsCenter' || $route.name == 'newsDetail'}"
        >{{$t('news')}}</router-link
      >
      <router-link :to="{ name: 'contact' }" tag="div" class="nav-item contact" :class="{'active': $route.name == 'contact'}">{{$t('contact')}}</router-link>
    </div>
    <Dropdown trigger="click" @on-click="langChange" class="nav-lang-item">
      <div>{{langName}}<Icon type="md-arrow-dropdown" style="margin-left: 4px;"/></div>
      <DropdownMenu slot="list">
        <DropdownItem v-show="langName == 'EN'" name="zh-CN">中文</DropdownItem>
        <DropdownItem v-show="langName == '中文'" name="en-US">EN</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Dropdown trigger="click" @on-click="langChange" class="drop-down" v-if="!isOpen">
      <div class="mobile-nav-item">{{langName}}<Icon type="md-arrow-dropdown" /></div>
      <DropdownMenu slot="list">
        <DropdownItem v-show="langName == 'EN'" name="zh-CN">中文</DropdownItem>
        <DropdownItem v-show="langName == '中文'" name="en-US">EN</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <div class="nav-menu" @click="isOpen = !isOpen">
      <Icon type="md-menu" size="44" />
    </div>
    <transition name="fade">
      <div class="mobile-menus" v-if="isOpen" @click="isOpen = false">
        <div class="menus">
          <router-link :to="{ name: 'aboutDetail' }" tag="div" class="menu-item">
            <div>{{$t('aboutUs')}}</div>
            <Icon type="ios-arrow-forward" />
          </router-link>
          <router-link :to="{ name: 'portfolio' }" tag="div" class="menu-item">
            <div>{{$t('portfolio')}}</div>
            <Icon type="ios-arrow-forward" />
          </router-link>
          <!-- <router-link :to="{ name: 'team' }" tag="div" class="menu-item">
            <div>{{$t('team')}}</div>
            <Icon type="ios-arrow-forward" />
          </router-link> -->
          <router-link :to="{ name: 'newsCenter' }" tag="div" class="menu-item">
            <div>{{$t('news')}}</div>
            <Icon type="ios-arrow-forward" />
          </router-link>
          <router-link :to="{name: 'contact'}" tag="div" class="menu-item">
            <div>{{$t('contact')}}</div>
            <Icon type="ios-arrow-forward" />
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'commonHeader',
  props: {
    isBlack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fixedTop: 186,
      isOpen: false,
      langName: localStorage.getItem('local') == 'zh-CN' ? '中文' : 'EN'
    }
  },
  mounted() {
    let width = document.body.clientWidth;
    this.fixedTop = width >= 992 ? 186 : 20;
    let scrollTop = document.documentElement.scrollTop || window.pageYOffset
    // console.log(scrollTop)
    if(scrollTop > this.fixedTop) {
      document.querySelector('.nav-container').classList.add('fixed')
    }else{
      document.querySelector('.nav-container').classList.remove('fixed')
    }
    window.addEventListener('scroll', () => {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset
      // console.log(scrollTop)
      if(scrollTop > this.fixedTop) {
        document.querySelector('.nav-container').classList.add('fixed')
      }else{
        document.querySelector('.nav-container').classList.remove('fixed')
      }
    })
    window.addEventListener('resize', () => {
      let width = document.body.clientWidth
      this.fixedTop = width >= 992 ? 186 : 20
    })
  },
  methods: {
    langChange(e) {
      if(localStorage.getItem('local') == e) return
      localStorage.setItem('local', e)
      this.langName = localStorage.getItem('local') == 'zh-CN' ? '中文' : 'EN'
      this.$i18n.locale = localStorage.getItem('local')
      this.$baseEventBus.$emit("lang");
    }
  }
}

</script>
<style lang="less">
  .nav-container {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 60px;
    z-index: 100;
    transition: all 0.5s;
    // background-color: #292929;
    &.active{
      background-color: #292929;
    }
    &.fixed {
      background: #ffffff;
      .nav-bar .nav-item {
        color: #000;
      }
      .nav-lang-item{
        color: #000;
      }
    }
    .logo {
      position: absolute;
      left: 2.916%;
      top: 50%;
      transform: translateY(-50%);
      width: 50px;
      height: 50px;
    }
    .nav-bar {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      display: flex;
      align-items: center;
      .nav-item {
        position: relative;
        color: #fff;
        white-space: nowrap;
        font-size: 17px;
        padding: 0 36px;
        cursor: pointer;
        // &.contact {
        //   padding-right: 25px;
        //   margin-right: 24px;
        //   &::before {
        //     content: "";
        //     position: absolute;
        //     right: 0;
        //     top: 50%;
        //     transform: translateY(-50%);
        //     height: 20px;
        //     width: 1px;
        //     background: #eeeeee;
        //   }
        // }
        &.active {
          &:after {
            content: "";
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -15px;
            width: 23px;
            height: 3px;
            background: #fd0505;
          }
        }
      }
    }
    .nav-lang-item{
      position: absolute;
      right: 2.916%;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      white-space: nowrap;
      font-size: 16px;
      // padding: 0 36px;
      cursor: pointer;
    }
    .drop-down{
      display: none;
    }
    .nav-menu {
      display: none;
    }
    .ivu-select-dropdown{
      padding: 0;
      // background: transparent;
      border-radius: 0;
    }
    .ivu-dropdown-menu{
      min-width: 60px!important;
      border: 1px solid #FFFFFF;
    }
    .ivu-dropdown-item{
      color: #000;
      background: #fff;
      &:hover{
        background: #fff;
      }
    }
  }
  @media screen and (max-width: 992px) {
    .nav-container {
      height: 1.76rem;
      &.fixed {
        .nav-menu {
          color: #666;
        }
        .mobile-nav-item{
          color: #666;
        }
      }
      .logo {
        position: absolute;
        left: 0.44rem;
        top: 50%;
        transform: translateY(-50%);
        width: 1.2rem;
        height: 1.2rem;
      }
      .nav-bar {
        display: none;
      }
      .nav-lang-item{
        display: none;
      }
      .drop-down{
        display: block;
        position: absolute;
        transform: translateY(-50%);
        right: 1.8rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
      }
      .mobile-nav-item{
        color: #fff;
        white-space: nowrap;
        font-size: 16px;
        padding: 0 .40rem;
        width: 1.6rem;
        box-sizing: border-box;
        cursor: pointer;
      }
      .nav-menu {
        display: block;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0.453333rem;
        z-index: 10;
      }
      .mobile-menus {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: flex-end;
        transition: all 0.5s;
        .menus {
          padding-top: 2.4rem;
          width: 36.4%;
          height: 100vh;
          background: #151B27;
          overflow-y: auto;
          box-sizing: border-box;
          .menu-item {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #DFE8F8;
            font-size: 15px;
            height: 1.813333rem;
            // width: 4.266667rem;
            box-sizing: border-box;
            cursor: pointer;
            margin: 0 .453333rem;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 1px;
              transform: scaleY(0.5);
              background: #575f6e;
            }
            .ivu-icon{
              color: #575F6E;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/header/index.vue